import React from 'react'

export const BibliographyBoxSettings = props => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
